import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { Block } from 'shared/components/Block';
import { SubTitle } from 'shared/components/SubTitle';
import { Description } from 'shared/components/Description';
import { UTP } from './constants';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';
import { FourthUtpBlock } from 'shared/components/FourthUtpBlock';
import { LinkButton, Responsive } from '@cian/ui-kit';
import { PRAVA_SOBSTVENNOSTI } from 'shared/constants/links';

export const ElectronicRegistration: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <Element name={ENavigation.ElReg}>
          <div className={styles['textblock-container']}>
            <div className={styles['fix-width']}>
              <Block>
                <SubTitle text="Электронная регистрация" />
                <Description
                  text={[
                    {
                      value: `Сервис для агентов, покупателей и продавцов недвижимости, который объединяет банки, Росреестр и удостоверяющие центры в одном онлайн-окне, цифровизируя процесс покупки недвижимости.`,
                    },
                  ]}
                />
              </Block>
            </div>
            <Responsive desktop>
              <div className={styles['btn']}>
                <LinkButton href={PRAVA_SOBSTVENNOSTI} fullWidth target="_blank">
                  Подробнее
                </LinkButton>
              </div>
            </Responsive>
          </div>
          <FourthUtpBlock utp={UTP} />
        </Element>
      </Wrapper>
    </div>
  );
};
